import {
  List,
  Datagrid,
  ReferenceField,
  FunctionField,
  Filter,
  ReferenceInput,
  AutocompleteInput,
  SelectInput,
  NumberField,
} from "react-admin";
import { CalendarView } from "./CalendarView";
import { Chip } from "@mui/material";
import PreviewIcon from "@mui/icons-material/Preview";
import { formatDateToFrenshFormat } from "../utils/formatDateToFrenshFormat";

const statusChoises = [
  { id: "PENDING", name: "En attente" },
  { id: "CONFIRMED", name: "Confirmé" },
  { id: "CANCELLED", name: "Annulé" },
];

const statusColorMap: Record<string, "success" | "warning" | "error"> = {
  PENDING: "warning",
  CONFIRMED: "success",
  CANCELLED: "error",
};

const statusListLabels: Record<string, string> = statusChoises.reduce(
  (acc, { id, name }) => ({ ...acc, [id]: name }),
  {}
);

const AppointmentFilter: React.FC = (props) => (
  <Filter {...props}>
    <ReferenceInput
      source="provider"
      reference="providers"
      label="Prestataire"
      perPage={50}
      alwaysOn
    >
      <AutocompleteInput
        optionText={(record) => `${record.internalCode} - ${record.name}`}
        fullWidth
        label="Prestataire"
        filterToQuery={(searchText: any) => ({
          filterTree: {
            operator: "or",
            operands: [
              {
                term: {
                  name: "name",
                  filterType: "like",
                  value: searchText,
                },
              },
              {
                term: {
                  name: "internalCode",
                  filterType: "like",
                  value: searchText,
                },
              },
            ],
          },
        })}
      />
    </ReferenceInput>
    <ReferenceInput
      source="outlet"
      reference="outlets"
      label="Exutoire"
      perPage={50}
      alwaysOn
    >
      <AutocompleteInput
        optionText={(record) => `${record.internalCode} - ${record.name}`}
        fullWidth
        label="Exutoire"
        filterToQuery={(searchText: any) => ({
          filterTree: {
            operator: "or",
            operands: [
              {
                term: {
                  name: "name",
                  filterType: "like",
                  value: searchText,
                },
              },
              {
                term: {
                  name: "internalCode",
                  filterType: "like",
                  value: searchText,
                },
              },
            ],
          },
        })}
      />
    </ReferenceInput>
    <SelectInput
      source="status"
      label="Statut"
      choices={statusChoises}
      alwaysOn
    />
  </Filter>
);

export const AppointmentList: React.FC = (props) => (
  <>
    <List
      {...props}
      filters={<AppointmentFilter />}
      title="Calendrier des RDV"
      sort={{ field: "scheduledAt", order: "ASC" }}
    >
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <ReferenceField
          source="provider"
          reference="providers"
          label="Prestataire"
          link={false}
        >
          <FunctionField render={(r) => `${r.internalCode} - ${r.name}`} />
        </ReferenceField>
        <ReferenceField
          source="outlet"
          reference="outlets"
          label="Exutoire"
          link={false}
        >
          <FunctionField render={(r) => `${r.internalCode} - ${r.name}`} />
        </ReferenceField>
        <NumberField
          source="quantityBin"
          label="Qté caisses pleines (demandé)"
          textAlign="center"
        />
        <NumberField
          source="quantityBinToBeCollected"
          label="Qté caisses vides (demandé)"
          textAlign="center"
        />
        <NumberField
          source="fullBinsCollectedCount"
          label="Qté caisses pleines (réel)"
          textAlign="center"
        />
        <NumberField
          source="emptyBinsDepositCount"
          label="Qté caisses vides (réel)"
          textAlign="center"
        />
        <FunctionField
          source="scheduledAt"
          textAlign="center"
          label="Date RDV"
          render={(record: any) =>
            record.scheduledAt
              ? formatDateToFrenshFormat(record.scheduledAt, true)
              : "-"
          }
        />
        <FunctionField
          source="executionDate"
          textAlign="center"
          label="Date execution RDV"
          render={(record: any) =>
            record.executionDate
              ? formatDateToFrenshFormat(record.executionDate, true)
              : "-"
          }
        />
        <FunctionField
          source="createdAt"
          textAlign="center"
          label="Date création RDV"
          render={(record: any) =>
            record.createdAt
              ? formatDateToFrenshFormat(record.createdAt, true)
              : "-"
          }
        />
        <FunctionField
          label="Lien QR exutoire"
          textAlign="center"
          render={(record) =>
            record.externalCollectLink && (
              <a
                href={record.externalCollectLink}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "inherit" }}
                onClick={(e: any) => {
                  e.stopPropagation();
                }}
              >
                <PreviewIcon />
              </a>
            )
          }
        />
        <FunctionField
          source="status"
          label="Statut"
          textAlign="center"
          render={(record) => (
            <Chip
              label={statusListLabels[record.status] ?? record.status}
              color={statusColorMap[record.status] || "default"}
              size="small"
            />
          )}
        />
      </Datagrid>
    </List>
    <CalendarView />
  </>
);
